module.exports = __webpack_public_path__ + "img/welcome_image.202e91df.png";